import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useLazyQuery, useApolloClient } from '@apollo/client';
import { SOCIAL_INTERACTION_TARGETS_QUERY } from '../graphql';
import { getPagedUrns, updateInteractionsCache } from '../helpers';
export const SocialCountersProvider = ({ children, urns }) => {
    const urnCacheRef = React.useRef([]);
    const apolloClient = useApolloClient();
    const [refetch, { data = {} }] = useLazyQuery(SOCIAL_INTERACTION_TARGETS_QUERY);
    React.useEffect(() => {
        const pagedUrns = getPagedUrns(urns, urnCacheRef.current);
        if (pagedUrns.length > 0)
            refetch({ variables: { urns: pagedUrns } });
    }, [urns]);
    React.useEffect(() => {
        var _a, _b;
        if ((_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.socialInteractionTargets) === null || _b === void 0 ? void 0 : _b.length) {
            data.viewer.socialInteractionTargets.forEach((interaction) => {
                updateInteractionsCache({
                    apolloClient,
                    interaction,
                    viewer: data.viewer,
                });
            });
            urnCacheRef.current = urns;
        }
    }, [data]);
    return _jsx(React.Fragment, { children });
};
SocialCountersProvider.displayName = 'SocialCountersProvider';
//# sourceMappingURL=social-counters-provider.js.map